import { render } from "./ReputacionFeedbackNew.vue?vue&type=template&id=2b960650&scoped=true"
import script from "./ReputacionFeedbackNew.vue?vue&type=script&lang=js"
export * from "./ReputacionFeedbackNew.vue?vue&type=script&lang=js"

import "./ReputacionFeedbackNew.vue?vue&type=style&index=0&id=2b960650&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b960650"]])

export default __exports__